import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0A0908] bg-noise px-5 text-center" data-testid="not-found">
      <p className="font-display text-7xl text-gold-gradient">404</p>
      <p className="mt-2 font-display text-2xl text-[#F4F1EA]">This page drifted away</p>
      <p className="mt-2 text-sm text-[#8C8578]">The page you're looking for doesn't exist.</p>
      <Link to="/">
        <Button className="mt-6 rounded-full bg-[#D4AF37] px-8 font-semibold text-[#0A0908] hover:bg-[#E5C158]">Go home</Button>
      </Link>
    </div>
  );
}
